import { render, staticRenderFns } from "./VendorLocation.vue?vue&type=template&id=23fd71a4&"
import script from "./VendorLocation.vue?vue&type=script&lang=js&"
export * from "./VendorLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports